import React from "react";
import Card from "../../../../components/Card/Card";
import CardBody from "../../../../components/Card/CardBody";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";
import { CustomizableTexts } from "../../../../components/CustomizableTexts/CustomizableTexts";
import { useFormContext } from "react-hook-form";
import FormTextTC from "../../../../components/Forms/FormTextTC";

export default function MWise() {
  const { vestigingId } = useFormContext();
  return (
    <>
      <Card sx={{ padding: "8px 16px" }}>
        <CardBody>
          <h3>
            <TranslationWrapper tDefault={"Mwise Setup"} tKey={"vestigingen.form.mwise.header"} />
          </h3>
          <FormSwitchTC
            name={"extra_settings__mwise_loyalty_enabled"}
            tDefault={"Enable MWise Loyalty"}
            tKey={"vestigingen.form.mwise.loyalty_enabled"}
          />
          <FormTextTC
            defaultValue={vestigingId}
            name={"custom_data.mwise.shopId"}
            tDefault={"M-Wise Shop Id"}
            tKey={"custom_data.mwise.shopId"}
          />
        </CardBody>
      </Card>
      <Card>
        <CardBody>
          <h2>
            <TranslationWrapper
              tDefault={"Customize texts"}
              tKey={"vestigingen.form.mwise.customizable-texts-header"}
            />
          </h2>
          <CustomizableTexts
            translatableTexts={["mwise loyalty - login header", "mwise loyalty - login body"]}
            vestigingId={vestigingId}
          />
        </CardBody>
      </Card>
    </>
  );
}
